module.exports = __webpack_public_path__ + "static/media/f3_image@2x.44ef5299.png";